import React from "react";
import piggyBankImg from "../../images/piggy-bank.svg";

const minimoPorPeriodicidade = {
    Mensal: 10,
    Trimestral: 25,
    Semestral: 50,
    Anual: 100,
    Única: 0,
    Livre: 0,
};

const DEFAULT_BASE_MIN_REFORCOS = 25;

const AmountForm = ({
    isPrazoCerto,
    selectedSerieName,
    montante,
    montanteProgramado,
    periodicidade,
    metodoPagamento,
    onChange,
    manualMode = false,
    manualFields = {},
    onManualChange = () => { },
    pageMinAmount,
    pageMaxAmount,
    pageTextoMontante,
}) => {
    const resolveLimits = () => {
        const minFromBe = Number(pageMinAmount);
        const maxFromBe = Number(pageMaxAmount);

        const minAmount =
            !Number.isNaN(minFromBe) && minFromBe > 0 ? minFromBe : 0;

        const maxAmount =
            !Number.isNaN(maxFromBe) && maxFromBe > 0 ? maxFromBe : 0;


        const baseMinReforcos =
            minAmount > 0 ? minAmount : DEFAULT_BASE_MIN_REFORCOS;

        return { minAmount, maxAmount, baseMinReforcos };
    };


    const buildValidationState = () => {
        const { minAmount, maxAmount, baseMinReforcos } = resolveLimits();

        const parsedMontante = parseFloat(montante || "");
        const hasMontante = montante !== "" && !Number.isNaN(parsedMontante);


        const montanteHabilitaReforcos =
            hasMontante &&
            !Number.isNaN(parsedMontante) &&
            parsedMontante >= baseMinReforcos &&
            (maxAmount <= 0 || parsedMontante <= maxAmount);

        const isBetweenBaseAnd100 =
            montanteHabilitaReforcos &&
            parsedMontante >= baseMinReforcos &&
            parsedMontante < 100;

        const isEqualOrAbove100 =
            montanteHabilitaReforcos && parsedMontante >= 100;

        let periodicidadeValue = periodicidade || "";
        if (!montanteHabilitaReforcos) {
            periodicidadeValue = "";
        } else if (isBetweenBaseAnd100 && !periodicidadeValue) {
            periodicidadeValue = "Mensal";
        }

        const reforcosFieldsDisabled = !montanteHabilitaReforcos;
        const periodicidadeDisabled =
            !montanteHabilitaReforcos || isBetweenBaseAnd100;

        const isSemReforcos =
            periodicidadeValue === "Livre" ||
            periodicidadeValue === "" ||
            periodicidadeValue === "Sem reforços periódicos";

        const montanteReforcosDisabled =
            !montanteHabilitaReforcos ||
            (isEqualOrAbove100 && isSemReforcos);

        const showMontanteError =
            hasMontante &&
            (Number.isNaN(parsedMontante) ||
                (minAmount > 0 && parsedMontante < minAmount) ||
                (maxAmount > 0 && parsedMontante > maxAmount));

        let montanteErrorMessage = "";
        if (showMontanteError) {
            if (Number.isNaN(parsedMontante)) {
                montanteErrorMessage = "Insira um valor numérico válido.";
            } else if (minAmount > 0 && parsedMontante < minAmount) {
                montanteErrorMessage = `Insira um valor superior a ${minAmount} €.`;
            } else if (maxAmount > 0 && parsedMontante > maxAmount) {
                montanteErrorMessage = `Insira um valor igual ou inferior a ${maxAmount.toLocaleString(
                    "pt-PT")} €.`;
            } else if (minAmount > 0 && maxAmount > 0) {
                montanteErrorMessage = `Insira um valor entre ${minAmount}€ e ${maxAmount.toLocaleString(
                    "pt-PT"
                )}€.`;
            }
        }

        const parsedProgramado = parseFloat(montanteProgramado || "");
        const hasProgramado =
            montanteProgramado !== "" && !Number.isNaN(parsedProgramado);

        const minProgramado =
            minimoPorPeriodicidade[periodicidadeValue] ??
            minimoPorPeriodicidade["Mensal"];

        const showMontanteProgramadoError =
            !montanteReforcosDisabled &&
            hasProgramado &&
            parsedProgramado < minProgramado;

        return {
            minAmount,
            maxAmount,
            baseMinReforcos,
            periodicidadeValue,
            reforcosFieldsDisabled,
            periodicidadeDisabled,
            montanteReforcosDisabled,
            showMontanteError,
            montanteErrorMessage,
            showMontanteProgramadoError,
            minProgramado,
        };
    };

    const {
        minAmount,
        maxAmount,
        periodicidadeValue,
        periodicidadeDisabled,
        montanteReforcosDisabled,
        showMontanteError,
        montanteErrorMessage,
        showMontanteProgramadoError,
        minProgramado,
    } = buildValidationState();

    const handleManual = (name) => (e) => {
        const val = e?.target?.value ?? e;
        onManualChange({ [name]: val });
    };

    const placeholderMontante =
        minAmount > 0 && maxAmount > 0
            ? `Insira entre ${minAmount}€ e ${maxAmount.toLocaleString(
                "pt-PT"
            )}€`
            : "Insira o montante";

    return (
        <div className="passo1-container">
            <div className="passo1-header">
                <div className="icone-porquinho">
                    <img
                        src={piggyBankImg}
                        alt="icone-porquinho"
                    />
                </div>
                <div className="passo1-title-box">
                    <div className="passo1-subtitulo">
                        {pageTextoMontante || "Comece já a poupar"}
                    </div>
                </div>
            </div>

            <div className="passo1-box">
                <div className="form-group">
                    <label className="label">Montante inicial</label>
                    <div className="montante-wrapper">
                        <input
                            type="number"
                            name="montante"
                            value={montante}
                            onChange={onChange}
                            className="dropdown-subscrpiton"
                            placeholder={placeholderMontante}
                        />
                        <span className="simbolo-euro">€</span>
                    </div>
                    {showMontanteError && (
                        <div className="erro-texto">
                            {montanteErrorMessage}
                        </div>
                    )}
                </div>

                {!isPrazoCerto && (
                    <>
                        <div className="form-group">
                            <label className="label">
                                Reforços periódicos (opcional)
                            </label>
                            <select
                                className="dropdown-subscrpiton"
                                name="periodicidade"
                                value={periodicidadeValue}
                                onChange={onChange}
                                disabled={periodicidadeDisabled}
                            >
                                <option value="">
                                    Defina a periodicidade
                                </option>
                                <option value="Mensal">
                                    Mensal (mín: 10 €)
                                </option>
                                <option value="Trimestral">
                                    Trimestral (mín: 25 €)
                                </option>
                                <option value="Semestral">
                                    Semestral (mín: 50 €)
                                </option>
                                <option value="Anual">
                                    Anual (mín: 100 €)
                                </option>
                                <option value="Livre">
                                    Sem reforços periódicos
                                </option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="label">
                                Montante dos reforços periódicos
                            </label>
                            <div className="montante-wrapper">
                                <input
                                    type="number"
                                    name="montanteProgramado"
                                    value={montanteProgramado}
                                    onChange={onChange}
                                    className="dropdown-subscrpiton"
                                    placeholder="Defina o montante"
                                    disabled={montanteReforcosDisabled}
                                />
                                <span className="simbolo-euro">€</span>
                            </div>
                            {showMontanteProgramadoError && (
                                <div className="erro-texto">
                                    {`Insira um montante igual ou superior a ${minProgramado} €.`}
                                </div>
                            )}
                        </div>
                    </>
                )}

                <div className="form-group">
                    <label className="label">
                        Método de pagamento
                    </label>
                    <select
                        className="dropdown-subscrpiton"
                        name="metodoPagamento"
                        value={metodoPagamento}
                        disabled
                    >
                        <option>Débito Direto</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default AmountForm;
